import { Field } from "./fields";

export class Dto {
  /**
 * The name of the item
 */
  name: string;

  /**
   * The consulting name of the item
   */
  consultingName: string;

  /**
   * The identifier of the item
   */
  id: number;

  /**
   * The description of the item for the business unit
   */
  descriptionBu: string;

  /**
   * The description of the item for the development team
   */
  descriptionDev: string;

  /**
   * Indicates whether the item represents a business unit
   */
  isBu: boolean;

  /**
   * Indicates whether the item is virtual
   */
  isVirtual: boolean;

  /**
   * The link to the DevOps platform for the item
   */
  devOpsLink: string;

  /**
   * The list of fields associated with the item
   */
  fields: Field[];

  /**
   * The identifier of the technical group associated with the item
   */
  technicalGroupId: number;

  /**
   * The identifier of the consulting group associated with the item
   */
  consultingGroupId: number;

  /**
   * The identifier of the key user group associated with the item
   */
  keyUserGroupId: number;

  /**
   * The identifier of the type associated with the item
   */
  typeId: number;

  /**
   * The version of the item in the development environment
   */
  devVersion: string;

  /**
   * The version of the item in the release candidate environment
   */
  rcVersion: string;

  /**
   * The version of the item in the user acceptance testing environment
   */
  uatVersion: string;

  /**
   * The version of the item in the production environment
   */
  prodVersion: string;

  /**
   * The environment where the item is deployed
   */
  environment: string;

  /**
   * The status of the item in the development environment
   */
  devStatus: string;

  /**
   * Indicates whether a change is requested for the item
   */
  isChangeRequested: boolean;

  /**
   * Indicates whether the item is used as a search model
   */
  isSearchModel: boolean;

  /**
   * Indicates whether the item is new
   */
  isNew: boolean;

  /**
   * Constructor
   */
  constructor(data?: any) {
    if (data) {
      this.name = data.name;
      this.consultingName = data.consultingName;
      this.id = data.id;
      this.isBu = data.isBu;
      this.isVirtual = data.isVirtual;
      this.descriptionBu = data.descriptionBu;
      this.descriptionDev = data.descriptionDev;
      this.devOpsLink = data.devOpsLink;
      this.fields = data.fields;
      this.technicalGroupId = data.technicalGroupId;
      this.consultingGroupId = data.consultingGroupId;
      this.keyUserGroupId = data.keyUserGroupId;
      this.devVersion = data.devVersion;
      this.rcVersion = data.rcVersion;
      this.uatVersion = data.uatVersion;
      this.prodVersion = data.prodVersion;
      this.environment = data.environment;
      this.devStatus = data.devStatus;
      this.isChangeRequested = data.isChangeRequested;
      this.isSearchModel = data.isSearchModel;
      this.isNew = data.isNew;
      this.typeId = data.typeId;
    }
  }
}
